module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/lindtbShop/ortho-field-config-translation.json
// module id = 1223
// module chunks = 0